import { render, staticRenderFns } from "./CambiarGdpr.vue?vue&type=template&id=a5921de4&scoped=true&"
import script from "./CambiarGdpr.vue?vue&type=script&lang=js&"
export * from "./CambiarGdpr.vue?vue&type=script&lang=js&"
import style0 from "./CambiarGdpr.vue?vue&type=style&index=0&id=a5921de4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5921de4",
  null
  
)

export default component.exports